import React from 'react'
import PropTypes from 'prop-types'
import reactStringReplace from 'react-string-replace'
import { getNewTranslationApi } from 'api/newTranslation/client'

const makeTranslateFunc = (translation) => (rawMessage = '', obj = {}) => {
  const message = (translation && translation[rawMessage]) || rawMessage
  if (typeof message === 'string') {
    const matches = message.match(/_\w+_/g)
    if (matches) {
      const pattern = matches.join('|')
      const formatted = reactStringReplace(
        message,
        new RegExp(`(${pattern})`, 'g'),
        (match) => {
          const matchedProperty = match.replace(/_/g, '')
          if (obj.hasOwnProperty(matchedProperty)) {
            return obj[matchedProperty]
          } else {
            return match
          }
        }
      )
      return Array.isArray(formatted) && formatted.every(t => typeof t === 'string' || typeof t === 'number') ? formatted.join('') : formatted
    }

    return message || ''
  }

  // React will throw error if we try to render normal javascript object
  // This to make sure that all returned values from this function is string
  return JSON.stringify(message) || ''
}

const defaultTranslationFunc = makeTranslateFunc()

export const TranslationContext = React.createContext({
  translation: {},
  t: defaultTranslationFunc
})

export const TranslationConsumer = TranslationContext.Consumer

export class TranslationProvider extends React.Component {
  static propTypes = {
    translation: PropTypes.object,
    showTranslationKey: PropTypes.bool,
    locale: PropTypes.string,
    origin: PropTypes.func,
    apiRoot: PropTypes.string
  }

  constructor (props) {
    super(props)
    const { translation, showTranslationKey } = this.props
    // Get initial translation from props at first in server-side.
    this.state = {
      translation: translation,
      t: showTranslationKey ? x => x : makeTranslateFunc(translation)
    }
  }

  // Update translation with locale changes in client-side
  async componentDidUpdate (prevProps) {
    const { locale, origin, apiRoot, showTranslationKey } = this.props
    const { locale: prevLocale } = prevProps
    if (locale !== prevLocale) {
      const translation = await getNewTranslationApi({ origin, apiRoot, lang: locale })
      const t = showTranslationKey ? x => x : makeTranslateFunc(translation)
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ t, translation })
    }
  }

  render () {
    const { children } = this.props
    return (
      <TranslationContext.Provider value={this.state}>
        {children}
      </TranslationContext.Provider>
    )
  }
}
